import { render, staticRenderFns } from "./SearchQuestionHeader.vue?vue&type=template&id=fd31a27e&"
import script from "./SearchQuestionHeader.vue?vue&type=script&lang=js&"
export * from "./SearchQuestionHeader.vue?vue&type=script&lang=js&"
import style0 from "./SearchQuestionHeader.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports